/* eslint-disable max-len */
import React from 'react';

const AlignRightIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
    <path
      fillRule="evenodd"
      d="M14.8 5H4.2a.2.2 0 0 0-.2.2v.6c0 .11.09.2.2.2h10.6a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2zm0 6H4.2a.2.2 0 0 0-.2.2v.6c0 .11.09.2.2.2h10.6a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2zm0-3H8.2a.2.2 0 0 0-.2.2v.6c0 .11.09.2.2.2h6.6a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2zm0 6h-4.6a.2.2 0 0 0-.2.2v.6c0 .11.09.2.2.2h4.6a.2.2 0 0 0 .2-.2v-.6a.2.2 0 0 0-.2-.2z"
    />
  </svg>
);

export default AlignRightIcon;
